import { render, staticRenderFns } from "./FoodSharePointAddOrEdit.vue?vue&type=template&id=2f2aa46d"
import script from "./FoodSharePointAddOrEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./FoodSharePointAddOrEdit.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports